export default __webpack_public_path__ + "static/media/852hz-awaken-intuition.20e04dcc.ogg";